import { render, staticRenderFns } from "./initOrg.vue?vue&type=template&id=5fd9db7a&scoped=true&"
import script from "./initOrg.vue?vue&type=script&lang=js&"
export * from "./initOrg.vue?vue&type=script&lang=js&"
import style0 from "./initOrg.vue?vue&type=style&index=0&id=5fd9db7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9db7a",
  null
  
)

export default component.exports